import { Input } from '@components/styled/Input.styled';
import styled from 'styled-components';

export const InputRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-items: center;
    column-gap: 10px;
    flex-basis: 100%;

    ${Input} {
        width: 200px;
        height: 50px;
    }
`;
